import type { CellValue, PromoMetricCell } from '../types';

const EMPTY_DISPLAY = '--';

/**
 * Numeric Promo Metric KPIs arrive as `{current, change, previous}`; `date` /
 * `string` KPIs arrive as plain scalars. This is the only place that decides
 * which of the two a cell is, so the columns hook and the renderers cannot drift.
 */
export const isCellValue = (cell: PromoMetricCell): cell is CellValue =>
    typeof cell === 'object' && cell !== null && 'current' in cell;

/** Sort key for a numeric column. Missing/unwrapped cells sort as 0, as before. */
export const promoCellNumber = (cell: PromoMetricCell): number => {
    if (isCellValue(cell)) return cell.current;
    return typeof cell === 'number' ? cell : 0;
};

/** Sort key for a `date` / `string` column — the raw scalar, so ISO dates sort chronologically. */
export const promoCellText = (cell: PromoMetricCell): string => {
    if (cell === null || cell === undefined || isCellValue(cell)) return '';
    return String(cell);
};

/**
 * Display text for a non-numeric cell. Dates are shown exactly as the backend
 * sent them (`2027-01-01`), so the report never disagrees with the API payload.
 */
export const formatPromoScalar = (cell: PromoMetricCell): string => promoCellText(cell).trim() || EMPTY_DISPLAY;
